import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dFunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect$dRandom from "../Effect.Random/index.js";
import * as Partial from "../Partial/index.js";
const sum = /* #__PURE__ */ Data$dFoldable.foldlArray(Data$dSemiring.numAdd)(0.0);
const pickByWeight = weightFn => xs => i => {
  const go = go$a0$copy => go$a1$copy => {
    let go$a0 = go$a0$copy, go$a1 = go$a1$copy, go$c = true, go$r;
    while (go$c) {
      const i1 = go$a0, v = go$a1;
      if (v.tag === "Cons") {
        if (v._2.tag === "Nil") {
          go$c = false;
          go$r = v._1;
          continue;
        }
        const w = weightFn(v._1);
        if (i1 < w) {
          go$c = false;
          go$r = v._1;
          continue;
        }
        go$a0 = i1 - w;
        go$a1 = v._2;
        continue;
      }
      if (v.tag === "Nil") {
        go$c = false;
        go$r = Partial._crashWith("pickByWeight: empty list");
        continue;
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go(i)(Data$dArray.toUnfoldable(Data$dList$dTypes.unfoldableList)(xs));
};
const weightedRandom = weightFn => values => {
  const $0 = sum(Data$dFunctor.arrayMap(weightFn)(values));
  return () => {
    const n = Effect$dRandom.random();
    return pickByWeight(weightFn)(values)(n * ($0 - 0.0) + 0.0);
  };
};
const weightedRandomN = n0 => weightFn => values => {
  const go = v => v1 => {
    if (v.length === 0) { return () => Data$dList$dTypes.Nil; }
    if (v1 === 0) { return () => Data$dList$dTypes.Nil; }
    const $0 = weightedRandom(x => weightFn(x._2))(Data$dFunctorWithIndex.mapWithIndexArray(Data$dTuple.Tuple)(v));
    return () => {
      const v2 = $0();
      const a$p = go((() => {
        const $1 = Data$dArray._deleteAt(Data$dMaybe.Just, Data$dMaybe.Nothing, v2._1, v);
        if ($1.tag === "Nothing") { return v; }
        if ($1.tag === "Just") { return $1._1; }
        $runtime.fail();
      })())(v1 - 1 | 0)();
      return Data$dList$dTypes.$List("Cons", v2._2, a$p);
    };
  };
  const $0 = go(values)(n0);
  return () => {
    const a$p = $0();
    return Data$dArray.fromFoldableImpl(Data$dList$dTypes.foldableList.foldr, a$p);
  };
};
export {pickByWeight, sum, weightedRandom, weightedRandomN};
